import React from 'react';

export function NewDocument() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="49"
      viewBox="0 0 49 49"
      style={{ marginLeft: 21 }}
    >
      <g
        id="Ársskýrsla"
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
      >
        <g
          id="Fylgiskjöl-ársskýrslu"
          stroke="#20446A"
          strokeWidth="2"
          transform="translate(-152 -142)"
        >
          <g id="Group" transform="translate(130 120.25)">
            <path
              id="Combined-Shape"
              d="M59.743 23l10.256 10.255L70 69.49H23.511V23h36.232z"
            ></path>
            <path
              id="Path"
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M58.9 23.132v9.916c0 .599.515 1.084 1.15 1.084h8.847"
            ></path>
            <g id="Atoms/Takkar/Ör-án-leggs-hægri" transform="rotate(90 5 51)">
              <path
                id="Path-Copy-3"
                d="M-3.9382716 14.9111111L5.5441358 4.07407407 15.0265432 14.9111111"
                transform="rotate(90 5.544 9.493)"
              ></path>
            </g>
            <path
              id="Line"
              strokeLinecap="square"
              d="M46.5 36.146L46.507 55.282"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}
